import React from 'react';
import { Spacer as Spacer$1 } from './Spacer.styles.js';

var Spacer = function Spacer(_a) {
  var _b = _a.xsSpacing,
      xsSpacing = _b === void 0 ? 'sm' : _b,
      _c = _a.lgSpacing,
      lgSpacing = _c === void 0 ? 'md' : _c;
  return React.createElement(Spacer$1, {
    xsSpacing: xsSpacing,
    lgSpacing: lgSpacing
  });
};

export { Spacer };